<template>
    <div>

        <vue-headful title="Employee Disciplinary Actions :: MeritEHS"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item active"><i class="fa fa-gavel"></i> Disciplinary Actions</li>
                <li class="ml-3">
                    <router-link class="btn btn-sm btn-success" :to="`/employees/disciplinary-actions/create`">
                        <i class="fa fa-plus"></i> Add
                    </router-link>
                </li>
            </ol>
        </h4>

        <ul class="search-nav nav nav-tabs tabs-alt container-p-x container-m--x mb-4 d-lg-flex d-none">
            <template v-for="(tab, key) in settingsTabs">
                <b-nav-item :active="curTab === key" @click="curTab = key">
                    {{ tab }}
                </b-nav-item>
            </template>
        </ul>

        <div class="mb-2 mb-lg-0 d-lg-none d-block">
          <b-dropdown :html="tabButtonTitle" variant="default" class="bg-white">
            <template v-for="(tab, key) in settingsTabs">
                <b-dropdown-item :active="curTab === key" @click="curTab = key">
                    {{ tab }}
                </b-dropdown-item>
            </template>
          </b-dropdown>
        </div>

        <div v-show="curTab == 'actions'">
            <saved-filter-title :filterKey="'discActionFilters'" />

            <div class="card">
                <div class="card-body">
                    <disciplinary-list ref="empDiscActionList" :allowFilterSaving="true" />
                </div>
            </div>
        </div>
        <template v-if="canManage">
            <div class="card" v-show="curTab == 'violations'">
                <div class="card-body">
                    <v-server-table url="/admin/disciplinary-violations" :columns="violationCols" :options="violationOptions">

                        <div slot="afterFilterWrapper" class="ml-md-2 ml-0 mt-md-0 mt-2 float-md-left">
                            <div class="clearfix d-md-none d-block"></div>
                            <router-link class="btn btn-outline-success" :to="`/employees/disciplinary-violations/create`">
                                <i class="fa fa-plus"></i> Add
                            </router-link>
                        </div>

                        <template slot="disc_violation_id" slot-scope="props">
                            <router-link :to="`/employees/disciplinary-violations/edit/${props.row.disc_violation_id}`" title="Edit Violation Type" class="btn btn-sm btn-light">
                                <i class="fa fa-edit"></i> Edit
                            </router-link>
                            <router-link :to="`/employees/disciplinary-violations/delete/${props.row.disc_violation_id}`" title="Delete Violation Type" class="btn btn-sm btn-light">
                                <span class="text-danger"><i class="fa fa-trash"></i> Delete</span>
                            </router-link>
                        </template>

                        <template slot="is_active" slot-scope="props">
                            <label class="badge badge-success" v-if="props.row.is_active == 1">Active</label>
                            <label class="badge badge-warning" v-else>Inactive</label>
                        </template>

                    </v-server-table>
                </div>
            </div>
            <div class="card" v-show="curTab == 'alerts'">
                <div class="card-body">
                    <v-client-table ref="discEmailAlerts" :columns="columns" :options="options" :data="alerts">

                        <div slot="afterFilter" class="ml-2">
                            <router-link class="btn btn-outline-success" :to="`/employees/disciplinary-actions/alerts/create`">
                                <i class="fa fa-plus"></i> Add
                            </router-link>
                        </div>

                        <template slot="id" slot-scope="props">
                            <router-link class="btn btn-sm btn-default" :to="`/employees/disciplinary-actions/alerts/edit/${props.row.id}`" title="Edit Alert">
                                <span class=""><i class="fa fa-edit"></i></span>
                            </router-link>
                            <router-link class="btn btn-sm btn-default" :to="`/employees/disciplinary-actions/alerts/delete/${props.row.id}`" title="Delete Alert" v-if="false">
                                <span class="text-danger"><i class="fa fa-trash"></i></span>
                            </router-link>
                        </template>

                        <template slot="is_active" slot-scope="props">
                            <label class="badge badge-success" v-if="props.row.is_active == 1">Active</label>
                            <label class="badge badge-warning" v-else>Inactive</label>
                        </template>

                        <template slot="child_row" slot-scope="props">
                            <div><strong>Conditions:</strong></div>
                            <div v-for="cond in props.row.conditions">
                                {{ cond.field_label }} {{ cond.logic }} {{ cond.cond_label }}
                            </div>

                            <div class="mt-2"><strong>Recipients:</strong></div>
                            <div v-for="recip in props.row.recipients">
                                {{ recip.target_type }}
                                <span v-if="recip.target_label && recip.target_label.FirstName">- {{ recip.target_label.FirstName }} {{ recip.target_label.LastName }}</span>
                                <span v-else-if="recip.target_label">- {{ recip.target_label }}</span>
                            </div>
                        </template>

                    </v-client-table>
                </div>
            </div>
        </template>

    </div>
</template>

<script>
    export default {

        data: function() {
            return {
                curTab: 'actions',
                alerts: [],
                columns: ['id', 'alert_name', 'is_active', 'description'],
                options: {
                    columnsDropdown: false,
                    headings: {
                        id: 'Actions',
                        alert_name: 'Alert Name',
                        is_active: 'Active',
                        description: 'Description',
                    },
                },

                violationCols: ['disc_violation_id', 'violation_name', 'penalty_name', 'bonus_disqual_time', 'is_active'],
                violationOptions: {
                    columnsDropdown: false,
                    headings: {
                        disc_violation_id: 'Edit',
                        violation_name: 'Violation',
                        penalty_name: 'Penalty',
                        bonus_disqual_time: 'Safety Bonus Disqualification',
                        is_active: 'Status',
                    },
                    orderBy: {
                        ascending: true,
                        column: 'disciplinary_violations.violation_name',
                    },
                    uniqueKey: 'disc_violation_id',
                },

                settingsTabs: {
                    actions: 'Disciplinary Actions',
                    violations: 'Violation Settings',
                    alerts: 'Email Alert Settings',
                },
            }
        },

        computed: {

            canManage(){
                //Send it
                return this.$root.hasPermission('employees.disciplinary.manage');
            },

            tabButtonTitle(){
                //Send it
                return '<i class="fa fa-bars"></i> ' + this.settingsTabs[this.curTab];
            },

        },

        methods: {
            //Load up
            getDiscAlerts(){
                //Send it
                this.$http
                    .get('/employees/disciplinary-actions/alerts/list')
                    .then(response => {
                        //Set all the data
                        this.alerts = response.data.alerts;
                    })
                    .catch(response => {
                        //Set
                    })
                    .then(() => {

                    });
            },
        },

        mounted(){
            //Send it
            if(this.canManage)
            {
                //Get the data
                this.getDiscAlerts();

                //Check for a hash
                if(window.location.hash)
                {
                    //Set the current tab
                    this.curTab = window.location.hash.replace('#', '');
                }
            }

            //Focus on the SEarch Input
            this.$refs.empDiscActionList.$refs.disciplinaryTable.$refs.genericFilter.focus();
        },
    }
</script>
